<template>
  <div class="auth auth--bg">
    <ul class="auth__menu auth__menu--color">
      <li class="auth__item auth--size">
        <a class="auth__link" :href=sofomLogin>
          <img
            alt="Ingresa"
            src="https://secure-cdn.cumplo.cl/assets/cumplo2017/ingresa-icon-1a87015a52235cb7d884a1ff4030f21c.svg">
          <span class="auth__link__text--ml"><b>Iniciar sesión</b></span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'LoginDesktop',
  data () {
    return {
      sofomLogin: `/login`,
      sofomSignup: `/registro`
    }
  }
}
</script>

<style lang="scss" scoped>
  @media (min-width: 1024px) {

  .auth__menu {
    list-style-type: none;
    padding: 0;
    margin: 1.5em;
    display: flex;
  }

  .auth__menu--color {
    color: $white;
  }

  .auth__item::before {
    content: '';
  }

  .auth__link {
    color: $white;
    font-size: .8em;
  }

  .auth__link__text--ml {
    margin-left: .5em;
  }

  .auth__link:hover {
    color: #b0de83;
  }

  .auth__item--ml {
    margin-left: 2em;
  }

  .auth--bg {
    background: $midnight-blue;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Navigation/Menu/Desktop/LoginDesktop.vue